/**
 * Vanilla Minecraft commands for tab-completion on the live event page.
 * Each entry has a command name and a usage hint.
 */
const MINECRAFT_COMMANDS = [
  { name: '/advancement', hint: 'grant|revoke <target> ...' },
  { name: '/attribute', hint: '<target> <attribute> get|set ...' },
  { name: '/ban', hint: '<target> [reason]' },
  { name: '/ban-ip', hint: '<address|target> [reason]' },
  { name: '/banlist', hint: '[ips|players]' },
  { name: '/bossbar', hint: 'add|get|list|remove|set ...' },
  { name: '/clear', hint: '<target> [item] [maxCount]' },
  { name: '/clone', hint: '<begin> <end> <destination> ...' },
  { name: '/damage', hint: '<target> <amount> [type]' },
  { name: '/data', hint: 'get|merge|modify|remove ...' },
  { name: '/datapack', hint: 'disable|enable|list ...' },
  { name: '/debug', hint: 'start|stop|function' },
  { name: '/defaultgamemode', hint: 'survival|creative|adventure|spectator' },
  { name: '/deop', hint: '<target>' },
  { name: '/difficulty', hint: 'peaceful|easy|normal|hard' },
  { name: '/effect', hint: 'clear|give <target> [effect] [duration]' },
  { name: '/enchant', hint: '<target> <enchantment> [level]' },
  { name: '/execute', hint: 'as|at|in|if|unless|run ...' },
  { name: '/experience', hint: 'add|set|query <target> <amount>' },
  { name: '/fill', hint: '<from> <to> <block> [mode]' },
  { name: '/fillbiome', hint: '<from> <to> <biome>' },
  { name: '/forceload', hint: 'add|remove|query <chunk>' },
  { name: '/function', hint: '<name>' },
  { name: '/gamemode', hint: 'survival|creative|adventure|spectator [target]' },
  { name: '/gamerule', hint: '<rule> [value]' },
  { name: '/give', hint: '<target> <item> [count]' },
  { name: '/help', hint: '[command]' },
  { name: '/item', hint: 'modify|replace ...' },
  { name: '/jfr', hint: 'start|stop' },
  { name: '/kick', hint: '<target> [reason]' },
  { name: '/kill', hint: '<target>' },
  { name: '/list', hint: '[uuids]' },
  { name: '/locate', hint: 'biome|poi|structure <name>' },
  { name: '/loot', hint: 'give|insert|replace|spawn ...' },
  { name: '/me', hint: '<action>' },
  { name: '/msg', hint: '<target> <message>' },
  { name: '/op', hint: '<target>' },
  { name: '/pardon', hint: '<target>' },
  { name: '/pardon-ip', hint: '<address>' },
  { name: '/particle', hint: '<name> [pos] [delta] [speed] [count]' },
  { name: '/place', hint: 'feature|jigsaw|structure|template ...' },
  { name: '/playsound', hint: '<sound> <source> <target> [pos] [vol]' },
  { name: '/publish', hint: '[allowCommands] [gamemode] [port]' },
  { name: '/random', hint: 'value|roll|reset ...' },
  { name: '/recipe', hint: 'give|take <target> <recipe>' },
  { name: '/reload', hint: '' },
  { name: '/return', hint: '<value>|fail|run ...' },
  { name: '/ride', hint: '<target> mount|dismount <vehicle>' },
  { name: '/save-all', hint: '[flush]' },
  { name: '/save-off', hint: '' },
  { name: '/save-on', hint: '' },
  { name: '/say', hint: '<message>' },
  { name: '/schedule', hint: 'function|clear <function> <time>' },
  { name: '/scoreboard', hint: 'objectives|players ...' },
  { name: '/seed', hint: '' },
  { name: '/setblock', hint: '<pos> <block> [mode]' },
  { name: '/setidletimeout', hint: '<minutes>' },
  { name: '/setworldspawn', hint: '[pos] [angle]' },
  { name: '/spawnpoint', hint: '<target> [pos] [angle]' },
  { name: '/spectate', hint: '<target> [player]' },
  { name: '/spreadplayers', hint: '<center> <spreadDist> <maxRange> ...' },
  { name: '/stop', hint: '' },
  { name: '/stopsound', hint: '<target> [source] [sound]' },
  { name: '/summon', hint: '<entity> [pos] [nbt]' },
  { name: '/tag', hint: '<target> add|list|remove <name>' },
  { name: '/team', hint: 'add|empty|join|leave|list|modify|remove ...' },
  { name: '/teammsg', hint: '<message>' },
  { name: '/teleport', hint: '<target> <destination|x y z>' },
  { name: '/tell', hint: '<target> <message>' },
  { name: '/tellraw', hint: '<target> <jsonMessage>' },
  { name: '/tick', hint: 'query|rate|step|sprint|unfreeze ...' },
  { name: '/time', hint: 'add|query|set <value>' },
  { name: '/title', hint: '<target> clear|reset|title|subtitle|actionbar|times ...' },
  { name: '/tm', hint: '<message>' },
  { name: '/tp', hint: '<target> <destination|x y z>' },
  { name: '/transfer', hint: '<hostname> [port]' },
  { name: '/trigger', hint: '<objective> [add|set <value>]' },
  { name: '/w', hint: '<target> <message>' },
  { name: '/weather', hint: 'clear|rain|thunder [duration]' },
  { name: '/whitelist', hint: 'add|list|off|on|reload|remove <target>' },
  { name: '/worldborder', hint: 'add|center|damage|get|set|warning ...' },
  { name: '/xp', hint: 'add|set|query <target> <amount>' },
];

export default MINECRAFT_COMMANDS;
